import { LegacyCard, Layout, Page, DropZone, LegacyStack, Thumbnail, Select, Text } from '@shopify/polaris';
import { HorizontalDotsMinor } from '@shopify/polaris-icons';
import { useCallback, useContext, useEffect, useState } from 'react';
import { SET_OK, SET_ERROR } from '../../../context/ToastReducer';
import ToastContext from '../../../context/ToastContext';
import { getCustomersList } from '../../../services/customersService';
import { postSellsFile } from '../../../services/sellsService';
import NotSoldDays from '../../UI/Sells/NotSoldDays';

const FormData = require('form-data');

const FileSells = () => {
  const [metadata, setMetadata] = useState([]);
  const [files, setFiles] = useState([]);
  const [options, setOptions] = useState([]);
  const [customerId, setCustomerId] = useState(1);
  const [, dispatchToast] = useContext(ToastContext);
  const [lastChange, setLastChange] = useState(new Date().toISOString());

  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) => setFiles((f) => [...f, ...acceptedFiles]),
    [],
  );

  const callDB = (page = 1, limit = 1000) =>
    getCustomersList({ page, limit })
      .then((res) => {
        setMetadata(res.data.metadata);
        const p = res.data.data.map((d) => ({ label: d.name, value: parseInt(d.id) }));
        setOptions(p);
        setCustomerId(parseInt(p[0].value));
      })
      .catch((e) => {
        throw e;
      });

  useEffect(() => {
    const page = metadata.page;
    callDB(page);
    // eslint-disable-next-line
  }, []);

  // const [selected, setSelected] = useState(options.map(o=>o.value)[0]);

  const handleSelectChange = (value) => {
    // setSelected(parseInt(value));
    setCustomerId(parseInt(value));
  };

  useEffect(() => {
    files.forEach((f) => {
      const form = new FormData();
      form.append('file', f, f.name);
      form.append('customerId', customerId);

      postSellsFile(form)
        .then((r) => {
          dispatchToast({ type: SET_OK, payload: r.data });
        })
        .catch((e) => {
          dispatchToast({ type: SET_ERROR, payload: e.response.data });
        })
        .finally(() => {
          setFiles([]);
          setLastChange(new Date().toISOString());
        });
    });
    // eslint-disable-next-line
  }, [files]);

  const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];

  const fileUpload = !files.length && <DropZone.FileUpload />;

  const uploadedFiles = files.length > 0 && (
    <LegacyStack vertical>
      {files.map((file, index) => (
        <LegacyStack alignment="center" key={index}>
          <Thumbnail
            size="small"
            alt={file.name}
            source={validImageTypes.includes(file.type) ? window.URL.createObjectURL(file) : HorizontalDotsMinor}
          />
          <div style={{ padding: 10 }}>
            {file.name}{' '}
            <Text variant="headingSm" as="h6">
              {file.size} bytes
            </Text>
          </div>
        </LegacyStack>
      ))}
    </LegacyStack>
  );

  return (
    <Page title="Ficheros EPH" divider>
      <Layout>
        <Layout.Section secondary>
          <Select label="Clientes" options={options} onChange={handleSelectChange} value={customerId} />
          <NotSoldDays refresh={lastChange} />
        </Layout.Section>
        <Layout.Section>
          <LegacyCard sectioned>
            <DropZone onDrop={handleDropZoneDrop}>
              {uploadedFiles}
              {fileUpload}
            </DropZone>
          </LegacyCard>
        </Layout.Section>
      </Layout>
    </Page>
  );
};

export default FileSells;
